import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import axios from 'axios';
import { computed, onMounted, Ref, ref } from 'vue';
import { APIS_IA } from '@/constants/apis';
import { TOKEN } from '@/constants/labels';
import CONSTMAPS from '@/constants/maps';
import CONSTAPIS from '@/constants/apis';

/********************************
 *********** LEAFTLET ***********
 *******************************/
import { LMap, LControlZoom,LTileLayer } from "@vue-leaflet/vue-leaflet";
import "/public/leaflet/leaflet.css";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const finalURL = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
    

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportMap',
  setup(__props) {

const zoomMap = computed( () => CONSTMAPS.zoom.value);
const centerMap:Ref<any> = ref([CONSTMAPS.latitud.value,CONSTMAPS.longitud.value])
const mapInstance:any = ref(null);

// Esta función se dispara cuando Leaflet termina de cargar
const onMapReady = (mapObject:any) => {
 // Guardamos la instancia del mapa para usarla con Javascript puro
  mapInstance.value = mapObject;
}

function getAllInfo() {
    axios.get(APIS_IA.value.getClusteringDataTestTransform, {
        headers: {
            'Authorization': `Bearer ${TOKEN}`
        }   
    }).then((response) => {
        const data = response.data;

        L.geoJSON(data, {
      // ESTILO: Aquí ocurre la magia visual
      style: (feature:any) => {
        return {
          color: 'white',        // Borde blanco fino entre hexágonos
          weight: 1,             // Grosor del borde
          fillColor: feature.properties.color, // <--- EL COLOR QUE VIENE DEL BACKEND
          fillOpacity: 0.6       // Transparencia para ver el terreno debajo
        };
      },
      // INTERACCIÓN: Popup al hacer click
      onEachFeature: (feature, layer) => {
        const p = feature.properties;
        const popupContent = `
          <div style="text-align:center">
            <h3 style="margin:0; color:${p.color}">Zona ${p.tasaFallo} Fallo</h3>
            <hr style="margin:5px 0">
            <b>Muestras:</b> ${p.muestras}<br>
            <b>Fallos:</b> ${p.fallos}<br>
            </div>
            `;
            // <small>ID: ${p.h3Id}</small>
        layer.bindPopup(popupContent);
      }
    }).addTo(mapInstance.value);
        console.log(data);
    }).catch((error) => {
        console.error('Error fetching data:', error);
    });
}



onMounted(() => {
    getAllInfo();
});


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "cardDashboard pa-8",
    color: "transparent",
    height: "750"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(LMap), {
        ref: "mapRef",
        class: "mapClassBorder",
        style: 'border: 4px solid white',
        zoom: zoomMap.value,
        center: centerMap.value,
        onReady: onMapReady,
        options: { zoomControl: false}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(LControlZoom), { position: 'topleft' }),
          _createVNode(_unref(LTileLayer), { url: finalURL })
        ]),
        _: 1
      }, 8, ["zoom", "center"])
    ]),
    _: 1
  }))
}
}

})